import { css } from "@emotion/core";

export const fontDinMixin = css`
  font-family: "din-condensed", sans-serif;
  font-weight: 400;
  font-style: normal;
`;
